import React from "react";
import { Icon, Poptip } from "@optimizely/axiom";
import { UserSearchSelector } from "../../UserSearchSelector/UserSearchSelector";
import { User } from "../../../../domain/User";

interface EmailSelectorInputProps {
    email: string | null;
    emailError?: string;
    onSelectUser: (user: User | undefined) => void | Promise<void>;
    onChange: (email: string) => void | Promise<void>;
    className?: string;
    disabled?: boolean;
}

export const EmailSelectorInput = ({
    email,
    emailError,
    onSelectUser,
    onChange,
    className = "push-quad--bottom soft-quad--sides",
    disabled = false
}: EmailSelectorInputProps) => {
    return (
        <div className={emailError ? `${className} oui-form-bad-news` : className}>
            <label className="oui-label">
                Email
                <span aria-label="(required)" className="oui-label--required" />
                <Poptip
                    className="push--left"
                    content="Enter the user's email. Existing users will appear for selection, with their details auto-filled. For new users, enter their info manually."
                    isInline
                >
                    <Icon name="circle-info" size="small" />
                </Poptip>
            </label>

            <UserSearchSelector
                placeholder="Enter the user's email..."
                onSelectUser={onSelectUser}
                lowerCaseInput
                onChange={onChange}
                value={email || ""}
                clearOnSelect={false}
                disabled={disabled}
            />

            {emailError && (
                <span className="oui-form-note" id="invitation-email-error">
                    {emailError}
                </span>
            )}
        </div>
    );
};

EmailSelectorInput.displayName = "EmailSelectorInput";
